import {Route, Routes} from "react-router-dom";
import {RecoilRoot} from "recoil";

/** Components */
import {useHasScope} from "../../config/globalConfig";
import ExpiredManagementConfiguration from "./expired-management-configuration/ExpiredManagementConfiguration";
import ExpiredManagementPracticesList from "./expired-management-practices-list/ExpiredManagementPracticesList";
import ExpiredPracticeDetail from "./expired-practice-detail/ExpiredPracticeDetail";
import PageNotFound from "../../util/page/PageNotFound";

const ExpiredManagementMain = () => {
   const hasScope = useHasScope;

    return (
        <Routes>
            <Route path="/expired-configuration" element={
                <RecoilRoot key={'expired-configuration'}>
                    <ExpiredManagementConfiguration />
                </RecoilRoot>
            } />

            <Route path="/practices-list" element={
                <RecoilRoot key={'expired-management-practices'}>
                    <ExpiredManagementPracticesList />
                </RecoilRoot>
            } />

            <Route path="/practice-detail/:id" element={
                <RecoilRoot key={'expired-management-practices'}>
                    <ExpiredPracticeDetail />
                </RecoilRoot>
            } />

            <Route path="/insert-practice/:id" element={
                <RecoilRoot key={'expired-management-practices'}>
                    <ExpiredPracticeDetail isInsertMode={true} />
                </RecoilRoot>
            } />

            <Route path="*" element={<PageNotFound/>}/>
        </Routes>
    );
}

export default ExpiredManagementMain;
